import React from 'react';
import { Link } from 'react-router-dom';
import visaCardLogo from '../../../icons/cards/visa.png';
import masterCardLogo from '../../../icons/cards/master card.png';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-links">
          <Link to="/terms-and-conditions">Terms and Conditions</Link>
          <Link to="/refund-cancellation-policy">Refund &amp; Cancellation Policy</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/contact-us">Contact Us</Link>
        </div>

        <div
          className="footer-payment-logos"
          role="img"
          aria-label="We accept Visa and Mastercard"
        >
          <img src={visaCardLogo} alt="" className="footer-card-logo" />
          <img src={masterCardLogo} alt="" className="footer-card-logo" />
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} flowdo. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;